<template>
    <canvas
            @mousedown="mouseDownHandler" @touchstart.prevent="mouseDownHandler"
            @mousemove="mouseMoveHandler" @touchmove.prevent="mouseMoveHandler"
            @mouseup="mouseUpHandler" @touchend.prevent="mouseUpHandler"
            :width="width"
            :height="height"
            :style="margin"
    ></canvas>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex'
    import { loadImage } from '../../assets/js/loadImageByPromise'
    import SampleScene from "../../assets/js/SampleScene"
    import Painter from '../../assets/js/paint'

    export default {
        name: "PaintCanvas",
        data: () => ({
            painter: {},
        }),
        async mounted() {
            this.createPainter();

            this.$root.$on('undo', this.undo);
            this.$root.$on('redo', this.redo);
            this.$root.$on('paint_clear', this.clear);
            this.$root.$on('paint_invert', this.invert);
            this.$root.$on('set_clipping_image', this.sendClippingImageToStore);
            this.$root.$on('save_paint_config', this.save);
            this.$root.$on('restore_paint_config', this.restore);
        },
        props: {
            width : Number,
            height: Number,
            margin: {
                type: Object,
                default: () => ({ marginTop: '0px', marginLeft: '0px'})
            }
        },
        computed: {
            ...mapState(['canvas_scale', 'background_img']),
            ...mapState('simulator', ['selected_scene']),
            ...mapState('paint', {rootPainter: 'painter'}),
            ...mapGetters('paint',{
                paint_config: 'paint_config'
            })
        },
        watch: {
            paint_config: function (new_config) {this.painter.updateConfig(new_config)},
            // async height() { //背景画像が新しくなったらpainterを作り直す
            //     await this.$nextTick();
            //     this.createPainter();
            // },
            async background_img () {
                this.createPainter();
                if (typeof this.selected_scene !== 'undefined' && this.selected_scene !== '') {
                    let [, sceneKey] = this.selected_scene.split('/');
                    sceneKey = sceneKey in SampleScene ? sceneKey : 'default';
                    const img = await loadImage(`assets/images/${SampleScene[sceneKey].clipping_image}`);
                    this.painter.setImage(img);
                    this.sendClippingImageToStore();
                } else {
                    const img = await loadImage('assets/images/no_clip.png');
                    this.painter.setImage(img);
                    this.sendClippingImageToStore();
                }
            }

        },
        methods: {
            ...mapMutations(['setClippingImage']),
            ...mapMutations('paint', ["setPainter"]),
            createPainter () {

                this.painter = new Painter(this.$el, this.paint_config);
                this.setPainter(this.painter);
            },
            mouseDownHandler(event) {
                event = event.touches ? this.getOffsetForTouchEvent(event) : event;
                this.painter.drawStart(event.offsetX, event.offsetY);
            },
            async mouseMoveHandler(event) {
                event = event.touches ? this.getOffsetForTouchEvent(event) : event;
                this.painter.draw(event.offsetX, event.offsetY);
            },
            mouseUpHandler(event) {
                event = event.touches ? this.getOffsetForTouchEvent(event) : event;
                this.painter.drawEnd(event.offsetX, event.offsetY);
            },
            save() {
                this.painter.save();
            },
            restore() {
                this.painter.restore();
            },
            undo() {
                this.painter.undo();
            },
            redo() {
                this.painter.redo();
            },
            clear() {
                this.painter.clear();
            },
            invert() {
                this.painter.invert();
            },
            async sendClippingImageToStore() {
                const img_el = await this.painter.getImage();
                this.setClippingImage(img_el);
            },
            getOffsetForTouchEvent(touchEvent) {
                const rect = touchEvent.target.getBoundingClientRect();
                const data = touchEvent.changedTouches ? touchEvent.changedTouches[0] : touchEvent.touches[0];
                return {
                    offsetX: (data.clientX - rect.left) / this.canvas_scale,
                    offsetY: (data.clientY - rect.top) / this.canvas_scale
                };
            },
        }
    }
</script>

<style scoped>
    canvas{
        /*background-color: aqua;*/
    }
</style>
